import * as React from 'react';
import { useState } from 'react';
import * as API from '../Utils/API.js';
import { htmlIf } from '../Utils/HTML';

type Props =
  { prompts: Prompt[]
  , modelVersion: string
  }

type Prompt = { promptKey: PromptKey, promptText: string }

enum PromptKey
  { QuestionGenerator = 'question-ai-question-prompt'
  , AnswerGenerator = 'question-ai-answer-prompt'
  , KeywordFilter = 'question-ai-keyword-prompt'
  }

export const PromptLabels: Record<PromptKey, string> = {
  [PromptKey.QuestionGenerator]: 'Question Generator',
  [PromptKey.AnswerGenerator]: 'Answer Generator',
  [PromptKey.KeywordFilter]: 'Keyword Filter',
}

const QuestionPrompts = (props: Props) => {
  return (
    <div>
      <div className="mb-3">Model Version: {props.modelVersion} </div>
      {props.prompts.map((prompt) => (
        QuestionPrompt(prompt)
      ))}
    </div>
  )
}

const QuestionPrompt = (props: Prompt) => {
  const [prompt, setPrompt] = useState(props);
  const [promptText, setPromptText] = useState(prompt.promptText);
  const [sampleInput, setSampleInput] = useState('');
  const [isTesting, setIsTesting] = useState(false);
  const [sampleOutput, setSampleOutput] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showRawOutput, setShowRawOutput] = useState(false);

  function save() {

    const postBody = { promptKey: prompt.promptKey, promptText: promptText }
    API.post("admin_questions_set_prompt_path", postBody).then(function (result) {
      if (result['error']) {
        // Handle error
      } else {
        setPrompt(result);
      }
    })
  }

  function test() {
    setIsTesting(true);
    setErrorMessage('');
    const postBody = { promptKey: prompt.promptKey, inputText: sampleInput, showRawOutput: showRawOutput }
    API.post("admin_questions_test_prompt_path", postBody).then(function (result) {
      if (result['error']) {
        setErrorMessage(result['error'])
        setIsTesting(false);
      } else {
        setSampleOutput(result['response'])
        setIsTesting(false);
      }
    })
  }

  return (
    <div className="mb-8">
      <div className="fs-xl fw-semibold">{PromptLabels[prompt.promptKey]}</div>
      <textarea
        className="form-control bg-white mt-1"
        rows={10}
        value={promptText}
        onChange={(event) => setPromptText(event.target.value)}
      />
      { prompt.promptText !== promptText
      ? <button className="btn btn-primary px-6 mt-2" onClick={save}>Save Prompt</button>
      : <div className="mt-1">
          <div className="fs-md mb-1">Test Message</div>
          <textarea
            className="form-control bg-white"
            rows={2}
            value={sampleInput}
            onChange={(event) => setSampleInput(event.target.value)}
            placeholder='Send a test message using the above prompt…'
          />
          <div className="d-flex justify-content-between align-items-center">
            <button className="btn btn-primary mt-1" disabled={isTesting || sampleInput.length < 1 } onClick={test}>Send test</button>
            <div className="d-flex">
              <label htmlFor='rawOutput' className="me-1">Show raw API output?</label>
              <input type='checkbox' className='form-check' id='rawOutput' onChange={() => setShowRawOutput(!showRawOutput)}/>
            </div>
          </div>
          {htmlIf(isTesting, <div className="mt-2 text-secondary">Waiting for a response…</div>)}
          {htmlIf(errorMessage.length > 0,<div className="mt-2 text-danger">Error: {errorMessage}</div>)}
          {htmlIf(sampleOutput.length > 0,
            <div className="mt-2">{sampleOutput}</div>
          )}
        </div>
      }
    </div>
  )
}

export default QuestionPrompts;
